import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const FullBuy = styled.div`
    display: block;
    width: 100%;
    padding-top: 60px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding-top: 69px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding-top: 24px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-top: 40px;
    }
`;

export const FullBuyByPage = styled.div<{ isNotNeedGap?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 40px;
    ${({ isNotNeedGap = false }) => !isNotNeedGap && css`
        row-gap: 40px;
    `}

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-top: 10px;
    }
`;

export const StageWrap = styled.section`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    align-items: flex-start;
`;

export const LeftSide = styled.div`
    flex: 1;
    flex-direction: column;
    gap: 32px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex: 0 1 auto;
        display: flex;
        width: 100%;
    }

    @media (max-width: 1350px) {
        flex-direction: column;
    }
`;

export const RightSide = styled.div<{ isLastStage?: boolean, isOnTimeslots?: boolean }>`
    z-index: 1;
    flex: 0 1 auto;
    display: flex;
    flex-direction: column;
    padding-top: ${p => p.isLastStage ? '78px' : p.isOnTimeslots ? '82px' : '48px'};

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 100%;
        max-width: 100%;
        ${p => p.isLastStage ? 'padding-top: 0px' : ''};
    }
`;

export const Title = styled.div`
    margin-top: 24px;
    width: 100%;
    padding: 0 16px;
    ${FONTS.XS};
    color: ${COLORS.TextPrimary};

    @media (min-width: ${wideBreakpoints.mobile}) {
        padding: 0;
    }
`;

/**
 * @deprecated use the @r1-frontend/ui-react/typography/heading H3
 */
export const BlockTitle = styled.div`
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};
    margin-bottom: 16px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H4};
    }
  
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const TextWrap = styled.div`
    flex: 1;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
`;

/**
 * @deprecated use the @r1-frontend/ui-react/typography/heading H3 or H4...
 */
export const Text = styled.div`
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H4};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H5};
    }
`;

export const Button = styled(BaseButton)`
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100% !important;
    }
`;
